import { render } from "./PayorForm.vue?vue&type=template&id=04b53d63&ts=true"
import script from "./PayorForm.ts?vue&type=script&lang=ts&external"
export * from "./PayorForm.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__